"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bezel = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var video_context_1 = require("../context/video-context");
/**
 * Flashes an icon on the screen when a shortcut key is used
 *
 * Currently only 'play' and 'pause' are implemented
 * @param className
 * @constructor
 */
var Bezel = function (_a) {
    var className = _a.className;
    var videoService = (0, video_context_1.useVideo)();
    var _b = React.useState(0), count = _b[0], setCount = _b[1];
    var _c = React.useState(''), action = _c[0], setAction = _c[1];
    var _d = React.useState(true), hidden = _d[0], setHidden = _d[1];
    var timerRef = React.useRef();
    var style = hidden
        ? {
            display: 'none',
        }
        : undefined;
    React.useEffect(function () {
        var subscription = videoService.subscribe(function (state) {
            if ((state.event.type === 'PLAY' || state.event.type === 'PAUSE') &&
                state.event.source === 'shortcut') {
                setAction(state.event.type.toLowerCase());
                if (timerRef.current) {
                    // previous animation is not finished
                    clearTimeout(timerRef.current); // cancel it
                    timerRef.current = undefined;
                }
                setCount(function (prevCount) { return prevCount + 1; });
                setHidden(false);
                // hide it after 0.5s
                timerRef.current = setTimeout(function () {
                    setHidden(true);
                    timerRef.current = undefined;
                }, 500);
            }
        });
        return subscription.unsubscribe;
    }, [videoService]);
    return (React.createElement("div", { className: (0, classnames_1.default)({
            'cueplayer-react-bezel': true,
            'cueplayer-react-bezel-animation': count % 2 === 0,
            'cueplayer-react-bezel-animation-alt': count % 2 === 1,
        }, className), style: style, role: "status" },
        React.createElement("div", { className: (0, classnames_1.default)('cueplayer-react-bezel-icon', "cueplayer-react-bezel-icon-".concat(action)) })));
};
exports.Bezel = Bezel;
